import { JSX } from 'react';
import mlCopyBlock from './ml-copy-block.variants';

// Components
import { AtHeader } from '@/components/atoms/at-header';
import { AtText } from '@/components/atoms/at-text/at-text';

// Types
import { EBlockAlignment } from '@/lib/contentstack-sdk/types';
import { ETextVariants } from '@/components/atoms/at-text/at-text.types';
import { IMlcopyBlockProps } from './ml-copy-block.types';

export const MlCopyBlock = ({
  header,
  title,
  eyebrow,
  subhead,
  children,
  alignment = EBlockAlignment.LEFT,
  titleElement = 'h2',
  titleVariant = 'h2',
}: IMlcopyBlockProps): JSX.Element => {
  const displayHeader = header || title;
  const variantClasses = mlCopyBlock({ alignment });
  return (
    <div className={variantClasses.base({ alignment })}>
      {eyebrow && (
        <AtText
          variant={ETextVariants.LABEL}
          className="pb-4 text-skin-tertiary lg:pb-6"
        >
          {eyebrow}
        </AtText>
      )}
      <AtHeader
        element={titleElement}
        className="pb-12 text-brand"
        variant={titleVariant}
      >
        {displayHeader}
      </AtHeader>
      {subhead && (
        <AtHeader element="p" variant="h6" className="pb-4 lg:pb-6">
          {subhead}
        </AtHeader>
      )}
      <span className={variantClasses.children({ alignment })}>{children}</span>
    </div>
  );
};
